<div class="not-found-page">
  <div class="not-found-page__img">
    <img src="../../../assets/images/404.jpg" alt="">
  </div>
  <div class="not-found-page__go-to-home" (click)="backToHome()">
    {{i18nService.data.global.goToHome}}
  </div>
</div>
